import { LogQuantityQuestion } from 'interfaces';
import { t } from 'services/i18n.service';
import { v4 as uuid } from 'uuid';
import LogQuantityQuestionsEditor from '../../log-data-tab/LogQuantityQuestionsEditor';

interface LogQuestionsProps {
  logQuestions: LogQuantityQuestion[];
  onLogQuestionsChange: (questions: LogQuantityQuestion[]) => void;
  choiceId?: string;
}

const LogQuestions = ({
  logQuestions,
  onLogQuestionsChange,
  choiceId
}: LogQuestionsProps) => (
  <LogQuantityQuestionsEditor
    questions={logQuestions}
    onQuestionsChange={onLogQuestionsChange}
    onCreateQuestionId={() => uuid()}
    compact
    rowKeyPrefix={choiceId ? `${choiceId}-` : ''}
    emptyMessage={t('tabs_revamp.activity_choices_tab.no_questions_added')}
  />
);

export default LogQuestions;
